import { Card, FormCardTitle, HookForm, HookInputField, HookSubmitButton, spacing } from "@litbase/alexandria";
import { client } from "@litbase/client";
import { useState } from "react";
import styled from "styled-components";
// @ts-expect-error
import logo from "../assets/diacare_logo.png";

export function LoginPage() {
  const [error, setError] = useState("");

  return (
    <Page>
      <Content>
        <img src={logo} />
        <h2>Clot App</h2>
        <Card>
          <HookForm<{ email: string; password: string }>
            onSubmit={async (values) => {
              try {
                await client.loginWithEmailAndPassword({ email: values.email, password: values.password });
              } catch (e) {
                const message = (e as unknown as [string, string])[1];
                switch (message) {
                  case "Email address or password incorrect":
                    setError("Helytelen felhasználónév vagy jelszó");
                    break;
                  default:
                    setError("Ismeretlen hiba történt");
                    break;
                }
              }
            }}
          >
            <FormCardTitle>
              <span>Bejelentkezés</span>
            </FormCardTitle>
            <HookInputField label="Email-cím" name="email" />
            <HookInputField label="Jelszó" name="password" type="password" />
            {error && <ErrorText>{error}</ErrorText>}
            <Row>
              <HookSubmitButton>Bejelentkezés</HookSubmitButton>
            </Row>
          </HookForm>
        </Card>
      </Content>
    </Page>
  );
}

const ErrorText = styled.span`
  color: red;
  margin-top: ${spacing._2};
  display: block;
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;

const Content = styled.div`
  max-width: 550px;
  width: 100%;
  button {
    margin-top: 1rem;
  }
  display: flex;
  flex-direction: column;
  img {
    margin: 0 auto;
  }
  h2 {
    margin: 0 auto;
    width: fit-content;
    margin-bottom: ${spacing._4};
  }
`;

const Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;
